import { Dialog, Sheet } from "@gravity-ui/uikit";
import { ProductDetailResponseDto } from "definitions/product-storage";

import { ProductContentWithPayment } from "../ProductModalContent";

interface ProductSheetProps {
  open: boolean;
  onClose: () => void;
  spuId: number;

  product: ProductDetailResponseDto | null;
  isLoading?: boolean;
  hasMoney?: boolean;
  hasSubscribe?: boolean;
}

export const ProductSheet = ({
  open,
  onClose,
  product,
  isLoading,
  hasMoney,
  hasSubscribe,
}: ProductSheetProps) => {
  return (
    <Sheet visible={open} onClose={onClose}>
      <Dialog.Body>
        <ProductContentWithPayment
          product={product}
          isLoading={isLoading}
          hasMoney={hasMoney}
          hasSubscribe={hasSubscribe}
        />
      </Dialog.Body>
    </Sheet>
  );
};
